import apiService from '../Api'
import { INotificationListResponse, IPollResponse } from './interfaces'

export class NotificationService {
  async list(page: number, pageSize = 15): Promise<INotificationListResponse> {
    return apiService.get('/notifications', { params: { page, page_size: pageSize } }).then((response) => response.data)
  }

  async poll(after: string): Promise<IPollResponse> {
    return apiService.get('/notifications/poll', { params: { after } }).then((response) => response.data)
  }

  async markAsRead(id: number): Promise<{ message: string }> {
    return apiService.post(`/notifications/${id}/read`).then((response) => response.data)
  }

  async markAllAsRead(): Promise<{ message: string }> {
    return apiService.post('/notifications/read-all').then((response) => response.data)
  }
}
